// removed by extract-text-webpack-plugin
module.exports = {"arrowIcon":"slider__arrowIcon--fb437f73","hiddenArrowIcon":"slider__hiddenArrowIcon--5ac2eade","pagingDotList":"slider__pagingDotList--e9a6ade7","pagingDotListItem":"slider__pagingDotListItem--2dc1a89c","pagingDotListItemActive":"slider__pagingDotListItemActive--3ff06347","pagingDotActive":"slider__pagingDotActive--4b7eed41","pagingDot":"slider__pagingDot--03760f0c","arrowLeft":"slider__arrowLeft--f2afc257","arrowRight":"slider__arrowRight--ea91cb30"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/slider.scss
// module id = 108
// module chunks = 0